import { Card, Container } from "react-bootstrap";
import { FaStar, FaCoins } from "react-icons/fa";
import { MdCircle } from "react-icons/md";
import "../../../assets/css/Customer/CustomerSettings/CustomerRideDetails.css";
import CustomerSettingsMasterLayout from '../../../layouts/Customer/CustomerSettingsMasterLayout';

/* ── Initials Avatar ── */
const InitialsAvatar = ({ name }) => {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
  return (
    <div className="CustomerRideDetails-driver-avatar-initials">
      {initials}
    </div>
  );
};

const CustomerRideDetails = () => {

  const rideData = {
    driver: {
      name: "Kamran Bashir",
      rating: 4.7,
      totalRatings: 214,
      vehicle: "Honda Civic — ABC-123",
    },
    rideInfo: {
      date: "3 Mar, 2025  |  09:30 AM",
      pickupLocation: "Gulberg III, Lahore, Pakistan",
      dropoffLocation: "DHA Phase 5, Lahore, Pakistan",
      duration: "28 min",
      distance: "12.4 km",
    },
    billDetails: {
      rideFare: "₨ 850",
      serviceFee: "₨ 75",
      couponSavings: "- ₨ 100",
      totalBill: "₨ 825",
    },
    paymentMethod: {
      paymentId: "#TRD-3041",
      paymentType: "Cash",
      status: "Paid",
    },
  };

  return (
    <CustomerSettingsMasterLayout screenName={"CustomerRideDetails"} centered={true}>
      <div className="CustomerRideDetails-wrapper">
        <Container className="CustomerRideDetails-container">

          {/* Driver Info Card */}
          <Card className="CustomerRideDetails-card CustomerRideDetails-driver-card">
            <Card.Body className="CustomerRideDetails-card-body">
              <div className="CustomerRideDetails-driver-info">
                <InitialsAvatar name={rideData.driver.name} />
                <div className="CustomerRideDetails-driver-details">
                  <h3 className="CustomerRideDetails-driver-name">
                    {rideData.driver.name}
                  </h3>
                  <p className="CustomerRideDetails-driver-vehicle">
                    {rideData.driver.vehicle}
                  </p>
                  <div className="CustomerRideDetails-driver-rating">
                    <FaStar className="CustomerRideDetails-star-icon" />
                    <span className="CustomerRideDetails-rating-value">
                      {rideData.driver.rating}
                    </span>
                    <span className="CustomerRideDetails-rating-count">
                      ({rideData.driver.totalRatings} reviews)
                    </span>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>

          {/* Ride Info Card */}
          <Card className="CustomerRideDetails-card">
            <Card.Body className="CustomerRideDetails-card-body">

              {/* Date */}
              <div className="CustomerRideDetails-date-row">
                <span className="CustomerRideDetails-date-label">Date & Time</span>
                <span className="CustomerRideDetails-date-value">{rideData.rideInfo.date}</span>
              </div>

              {/* Stats row */}
              <div className="CustomerRideDetails-stats-row">
                <div className="CustomerRideDetails-stat-item">
                  <span className="CustomerRideDetails-stat-value">{rideData.rideInfo.distance}</span>
                  <span className="CustomerRideDetails-stat-label">Distance</span>
                </div>
                <div className="CustomerRideDetails-stat-divider" />
                <div className="CustomerRideDetails-stat-item">
                  <span className="CustomerRideDetails-stat-value">{rideData.rideInfo.duration}</span>
                  <span className="CustomerRideDetails-stat-label">Duration</span>
                </div>
              </div>

              {/* Locations */}
              <div className="CustomerRideDetails-locations">
                <div className="CustomerRideDetails-location-item">
                  <MdCircle className="CustomerRideDetails-location-icon CustomerRideDetails-pickup-icon" />
                  <div>
                    <p className="CustomerRideDetails-location-tag">Pickup</p>
                    <span className="CustomerRideDetails-location-text">
                      {rideData.rideInfo.pickupLocation}
                    </span>
                  </div>
                </div>
                <div className="CustomerRideDetails-location-connector" />
                <div className="CustomerRideDetails-location-item">
                  <MdCircle className="CustomerRideDetails-location-icon CustomerRideDetails-dropoff-icon" />
                  <div>
                    <p className="CustomerRideDetails-location-tag">Dropoff</p>
                    <span className="CustomerRideDetails-location-text">
                      {rideData.rideInfo.dropoffLocation}
                    </span>
                  </div>
                </div>
              </div>

            </Card.Body>
          </Card>

          {/* Bill Details Card */}
          <Card className="CustomerRideDetails-card">
            <Card.Body className="CustomerRideDetails-card-body">
              <h3 className="CustomerRideDetails-section-title">Bill Details</h3>

              <div className="CustomerRideDetails-bill-row">
                <span className="CustomerRideDetails-bill-label">Ride Fare</span>
                <span className="CustomerRideDetails-bill-value">{rideData.billDetails.rideFare}</span>
              </div>
              <div className="CustomerRideDetails-bill-row">
                <span className="CustomerRideDetails-bill-label">Service Fee</span>
                <span className="CustomerRideDetails-bill-value">{rideData.billDetails.serviceFee}</span>
              </div>
              <div className="CustomerRideDetails-bill-row">
                <span className="CustomerRideDetails-bill-label">Coupon Savings</span>
                <span className="CustomerRideDetails-bill-value CustomerRideDetails-savings">
                  {rideData.billDetails.couponSavings}
                </span>
              </div>
              <div className="CustomerRideDetails-bill-row CustomerRideDetails-total-row">
                <span className="CustomerRideDetails-bill-label CustomerRideDetails-total-label">Total Bill</span>
                <span className="CustomerRideDetails-bill-value CustomerRideDetails-total-value">
                  {rideData.billDetails.totalBill}
                </span>
              </div>
            </Card.Body>
          </Card>

          {/* Coins Earned Card */}
          <Card className="CustomerRideDetails-card CustomerRideDetails-coins-card">
            <Card.Body className="CustomerRideDetails-card-body CustomerRideDetails-coins-body">
              <FaCoins size={22} className="CustomerRideDetails-coins-icon" />
              <div>
                <p className="CustomerRideDetails-coins-title">Coins Earned</p>
                <p className="CustomerRideDetails-coins-value">+ 85 Coins</p>
              </div>
            </Card.Body>
          </Card>

          {/* Payment Method Card */}
          <Card className="CustomerRideDetails-card">
            <Card.Body className="CustomerRideDetails-card-body">
              <h3 className="CustomerRideDetails-section-title">Payment Method</h3>

              <div className="CustomerRideDetails-payment-row">
                <span className="CustomerRideDetails-payment-label">Payment ID</span>
                <span className="CustomerRideDetails-payment-value">{rideData.paymentMethod.paymentId}</span>
              </div>
              <div className="CustomerRideDetails-payment-row">
                <span className="CustomerRideDetails-payment-label">Payment Type</span>
                <span className="CustomerRideDetails-payment-value">{rideData.paymentMethod.paymentType}</span>
              </div>
              <div className="CustomerRideDetails-payment-row">
                <span className="CustomerRideDetails-payment-label">Status</span>
                <span className="CustomerRideDetails-payment-value CustomerRideDetails-status-paid">
                  {rideData.paymentMethod.status}
                </span>
              </div>
            </Card.Body>
          </Card>

        </Container>
      </div>
    </CustomerSettingsMasterLayout>
  );
};

export default CustomerRideDetails;